export default __webpack_public_path__ + "static/media/cookie3.ec577107.svg";